<!--Modals-->
<app-deprecated-confirmation-dialog
    #confirmTaskDeleteDialog
    [label]="'Delete'"
    [negative]="true"
></app-deprecated-confirmation-dialog>

<app-deprecated-modal #taskDetailsModal [noBorder]="true">
    <app-task-details #taskDetails [employee]="employee" [task]="currentTask" (close)="onClose()"></app-task-details>

    <div class="actions close-button flex justify-end">
        <ui-button type="ghost" (click)="onClose()">{{ 'close' | appTranslate }}</ui-button>
    </div>
</app-deprecated-modal>

<app-deprecated-modal #pdfPreviewModal tall="true">
    <app-pdf-viewer #pdfViewer></app-pdf-viewer>
</app-deprecated-modal>

<!--Body-->
<div
    class="task-container scroll"
    *ngIf="tasks.length"
    (scroll)="onScrollContainer()"
    #container
    [class.dashboard]="onDashboard"
>
    <div class="task-checklist-content" role="list">
        <div
            class="task cursor"
            *ngFor="let task of tasks; let i = index; let last = last"
            [class.last-item]="last"
            (click)="onViewTaskDetails(task)"
            role="listitem"
            [attr.aria-labelledby]="'task-' + i"
        >
            <form #form="ngForm">
                <div class="wrapper">
                    <!--Hidden elm to add validation for file attachment field-->
                    <input
                        name="file{{ i }}"
                        type="hidden"
                        [(ngModel)]="task.fileId"
                        [required]="task.isAttachmentRequired"
                    />

                    <!-- first row -->
                    <div class="header">
                        <!-- Checkbox & Task name -->
                        <div class="title">
                            <mat-checkbox
                                [checked]="task.isComplete()"
                                (click)="$event.stopPropagation(); onToggleTaskComplete($event, task, form)"
                                [aria-describedby]="form.submitted && form.invalid ? 'file-error-' + i : ''"
                                ><span [id]="'task-' + i" [class.complete]="task.isComplete()">{{
                                    task.name
                                }}</span></mat-checkbox
                            >
                        </div>
                        <!--Sub tasks-->
                        <div class="subtasks" *ngIf="task.totalSubtasksCount > 0">
                            <span class="subtasks-info"
                                >{{
                                    {
                                        key: 'employees.task-checklist.getCompletedSubtasksCount',
                                        params: {
                                            completedSubtaskCount: getCompletedSubtasksCount(task),
                                            totalSubtasksCount: task.totalSubtasksCount,
                                        },
                                    } | appTranslate
                                }}
                            </span>

                            <span class="divider">|</span>
                        </div>

                        <div class="date">
                            <!--Completed date-->
                            <ng-container *ngIf="task.isComplete()">
                                <div class="completedAt">
                                    {{
                                        {
                                            key: 'employees.task-checklist.completedOnTaskcompletedAt',
                                            params: { date: task.completedAt | appDate },
                                        } | appTranslate
                                    }}
                                </div>
                            </ng-container>

                            <!--Incomplete date/Past due-->
                            <ng-container *ngIf="!task.isComplete()">
                                <div
                                    class="dueAt"
                                    *ngIf="task.dueAt; else noDueDate"
                                    [ngClass]="{ pastDue: task.isPastDueDay() }"
                                >
                                    {{
                                        {
                                            key: 'employees.task-checklist.dueTaskdueAt',
                                            params: { date: task.dueAt | appDate },
                                        } | appTranslate
                                    }}
                                </div>
                                <ng-template #noDueDate>
                                    <span class="dueAt">{{ 'employees.task-checklist.noDueDate' | appTranslate }}</span>
                                </ng-template>
                            </ng-container>
                        </div>
                        <!-- meatball-->
                        <div *ngIf="isAdmin" class="meatball">
                            <ng-container *ngIf="task.isComplete()">
                                <ui-button
                                    (click)="$event.preventDefault(); $event.stopPropagation()"
                                    [matMenu]="matMenu"
                                    class="meatball tab-menu margin-left-1"
                                    size="no-padding"
                                    aria-label="{{ task.name }} {{ 'screen-reader-only.moreActions' | translate }}"
                                >
                                    <mat-icon svgIcon="meatballHorizontal"></mat-icon>
                                </ui-button>
                                <mat-menu #matMenu xPosition="before">
                                    <button mat-menu-item (click)="onDelete(task)">
                                        {{ 'delete' | appTranslate }}
                                    </button>
                                </mat-menu>
                            </ng-container>

                            <ng-container *ngIf="!task.isComplete()">
                                <ui-button
                                    (click)="$event.preventDefault(); $event.stopPropagation()"
                                    [matMenu]="matMenu"
                                    class="meatball tab-menu margin-left-1"
                                    size="no-padding"
                                    aria-label="{{ task.name }} {{ 'screen-reader-only.moreActions' | translate }}"
                                >
                                    <mat-icon svgIcon="meatballHorizontal"></mat-icon>
                                </ui-button>
                                <mat-menu #matMenu xPosition="before">
                                    <button
                                        *ngIf="task.assignees && !onDashboard"
                                        mat-menu-item
                                        (click)="onRemind(task)"
                                    >
                                        {{ 'remind' | appTranslate }}
                                    </button>
                                    <button mat-menu-item (click)="onEdit(task, $event)">
                                        {{ 'edit' | appTranslate }}
                                    </button>
                                    <button mat-menu-item (click)="onDelete(task)">
                                        {{ 'delete' | appTranslate }}
                                    </button>
                                </mat-menu>
                            </ng-container>
                        </div>
                    </div>

                    <!-- second row with assignees-->
                    <div class="app-grid margin-left-3">
                        <div class="columns-12 assignment">
                            <!--Subject-->
                            <span *ngIf="task.taskType === taskTypes.onboarding && task.subject"
                                >{{
                                    {
                                        key: 'employees.task-checklist.taskSubjectOnboarding',
                                        params: { fullName: task.subject.fullName },
                                    } | appTranslate
                                }}
                            </span>
                            <span *ngIf="task.taskType === taskTypes.offboarding && task.subject"
                                >{{
                                    {
                                        key: 'employees.task-checklist.taskSubjectOffboarding',
                                        params: { fullName: task.subject.fullName },
                                    } | appTranslate
                                }}
                            </span>
                            <span *ngIf="task.taskType === taskTypes.general && task.subject"
                                >{{
                                    {
                                        key: 'employees.task-checklist.taskSubjectGeneral',
                                        params: { fullName: task.subject.fullName },
                                    } | appTranslate
                                }}
                            </span>

                            <!--Assignees-->
                            <div *ngIf="task.assigneeType || task.assignees.length" class="assignees">
                                <span>{{ 'employees.task-checklist.assignedTo' | appTranslate }}</span>

                                <app-avatar
                                    *ngIf="task.assigneeType === 'subject'"
                                    [showBorder]="true"
                                    [employee]="task.subject"
                                    [name]="true"
                                    size="font-fixed"
                                ></app-avatar>

                                <app-avatar
                                    *ngIf="task.assigneeType === 'manager'"
                                    [showBorder]="true"
                                    [employee]="task.assignees[0]"
                                    [name]="true"
                                    size="font-fixed"
                                ></app-avatar>

                                <div
                                    class="margin-left-1"
                                    *ngIf="
                                        task.assigneeType !== 'subject' &&
                                        task.assigneeType !== 'manager' &&
                                        task.assignees.length
                                    "
                                >
                                    <app-inline-avatars
                                        [numberOfEmployeesToShow]="5"
                                        [showEmployeeName]="true"
                                        [employees]="task.assignees"
                                        size="font-fixed"
                                        [showShortNameCopy]="true"
                                        [withMargins]="false"
                                    >
                                    </app-inline-avatars>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--third row with file-->
                    <div *ngIf="task.isAttachmentRequired" class="app-grid margin-left-2">
                        <div class="columns-12 attach-file">
                            <!-- File drop -->
                            <div *ngIf="task.isAttachmentRequired && !task.fileId" (click)="$event.stopPropagation()">
                                <app-file-drop
                                    (filesSelected)="onFileSelected($event, task)"
                                    [inlineView]="true"
                                    [allowedTypes]="allowedFileTypes"
                                    [required]="true"
                                ></app-file-drop>
                            </div>

                            <!--Error message-->
                            <mat-error id="file-error-{{ i }}" *ngIf="form.submitted && form.invalid"
                                ><span class="margin-top-1 margin-bottom-1"
                                    >{{ 'employees.task-checklist.fileAttachmentIsRequired' | appTranslate }}
                                </span></mat-error
                            >

                            <!-- Display file name -->
                            <div *ngIf="task.isAttachmentRequired && task.fileId">
                                <div
                                    class="file cursor"
                                    (click)="$event.preventDefault(); $event.stopPropagation(); viewFile(task.file)"
                                >
                                    <mat-icon svgIcon="attach" />
                                    {{ task.filename }}

                                    <ui-button
                                        type="link"
                                        size="no-padding"
                                        (click)="$event.preventDefault(); $event.stopPropagation(); onFileRemoved(task)"
                                    >
                                        <mat-icon svgIcon="close" />
                                    </ui-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
